<template>
  <div class="dimension-eq-condition-editor">
    <div
      v-if="dimensionValues"
      class="ref-select w-full mt-4">
      <singleselect
        v-model="keyValue"
        class="select-input"
        :return-as-object="false"
        :options="dimensionValues"
        :loading="loadingValues"
        label="value"
        track-by="key"
        header-placeholder="Select a Value..." />
      <ValidationErrors :errors="keyValueErrors" />
    </div>
    <div v-else-if="!loadingValues">
      Please select a valid dimension!
    </div>
  </div>
</template>

<script>

  import singleselect from '@/components/ui/singleselect.vue'
  import ObjectEditorMixin from '@/components/reports/config/common/ObjectEditorMixin'
  import { mapChildren } from '@/components/reports/config/common/objectUtil'

  export default {
    name: 'DimensionEqConditionEditor',
    components: {
      singleselect,
    },
    mixins: [
      ObjectEditorMixin,
    ],
    props: {
      context: {
        type: Object,
        default: Object,
      },
    },
    computed: {
      dimensionValues () {
        return this.context.dimensionValues || []
      },
      loadingValues () {
        return this.context.loadingValues || false
      },
      ...mapChildren({
        keyValue: 'key_value',
      }),
    },
  }

</script>

<style lang="scss" scoped>
.dimension-eq-condition-editor {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.select-input {
  min-width: 300px
}
</style>
